import * as devisConf from '@/configuration/devisConf';
import { CATEGORIE_DIVERS } from '@/configuration/produitConf';
import {
  calculHonoraire,
  getTotalAvecRemiseLocation, getTotalAvecRemiseTlpe, getTotalAvecRemiseDivers,
} from '@/services/devisCommandes/calcul/calculHonoraire';
import calculLigneNormalDevis from '@/services/devisCommandes/calcul/calculLigneCommandeNormal';

export default function findAndCalculHonoraire(listeLigneCommande) {
  listeLigneCommande
    .filter((ligne) => {
      return ligne.type === devisConf.REGROUPEMENT && ligne.lignesCommande;
    })
    .forEach((ligneRegroupement) => {
      ligneRegroupement.lignesCommande
        .filter((ligneEnfant) => {
          return ligneEnfant.typeProduit === CATEGORIE_DIVERS && ligneEnfant.calculAutomatiqueTlpe
            && ligneEnfant.produit && ligneEnfant.produit.produitDivers
            && ligneEnfant.produit.produitDivers.honoraire;
        })
        .forEach((ligneEnfantHonoraire) => {
          ligneEnfantHonoraire.uniteVente = devisConf.UNITE;
          ligneEnfantHonoraire.quantite = 1;
          ligneEnfantHonoraire.lignesRemise = [];
          ligneEnfantHonoraire.remise = 0;
          ligneEnfantHonoraire.prixUnitaire = calculHonoraire(
            ligneEnfantHonoraire.modeCalculHonoraire,
            getTotalAvecRemiseLocation(ligneRegroupement),
            getTotalAvecRemiseTlpe(ligneRegroupement),
            getTotalAvecRemiseDivers(ligneRegroupement),
          );
          calculLigneNormalDevis(ligneEnfantHonoraire);
        });
    });
}
